import { render, staticRenderFns } from "./TrademarkPublicationTypeList.vue?vue&type=template&id=399a777c&"
import script from "./TrademarkPublicationTypeList.vue?vue&type=script&lang=js&"
export * from "./TrademarkPublicationTypeList.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkPublicationTypeList.vue?vue&type=style&index=0&id=399a777c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports